import { render, staticRenderFns } from "./EcoHubTechUserDetail.vue?vue&type=template&id=4bfd60f8"
import script from "./EcoHubTechUserDetail.vue?vue&type=script&lang=js"
export * from "./EcoHubTechUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports